import { message } from "@carbon/shared";

/**
 * Note: message utils have been migrated to @carbon/shared. They are re-exported
 *       here for legacy usage of form-messages and should be phased out
 */
export const requiredMessage = message.isRequired;
export const mustBeNumber = message.mustBeNumber;
export const pleaseSelect = message.pleaseSelect;
